<template>
  <simple-image-page
    page-label="חסכונות עם רייזאפ"
    :img-src="require('@/assets/saving-zone/no-funds-header-image.svg')"
    title="למה לחסוך איתנו?"
    title-label="קופת גמל להשקעה"
    text="אפשר לפתוח חיסכון דרכנו ולהעביר אליו בקלות סכומים משתנים ישירות מהתזרים.
        בלי טופסולוגיה. בלי כאב ראש. בכמה דקות."
    :button-props="buttonProps"
  />
</template>

<script>
import OpenKglFlowAction
  from '@/pages/responsive-pages/authenticated/navigation-pages/saving-zone/components/OpenKglFlowAction';
import Segment from '@/Segment';
import SimpleImagePage from '@/base-components/SimpleImagePage';

export default {
  name: 'EmptyState',
  mixins: [OpenKglFlowAction],
  components: {
    SimpleImagePage,
  },
  methods: {
    openKGLClicked() {
      Segment.trackUserInteraction('MySavings_VpStartSaveKGL');
      this.openKGLFlow();
    },
  },
  computed: {
    buttonProps() {
      return {
        title: 'לפתיחת קופה ב-5 דק׳!',
        action: this.openKGLClicked,
      };
    },
  },
};
</script>

<style>

</style>
